import React from 'react';
import './Navigation.css';

const NavigationItem = ({ 
  children, 
  active = false,
  onClick,
  className = '',
  icon,
  ...props 
}) => {
  const baseClasses = 'nav-item';
  const activeClasses = active ? 'nav-item-active' : '';
  
  const classes = [baseClasses, activeClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classes}
      onClick={onClick}
      {...props}
    >
      {icon && (
        <span className="nav-item-icon">
          {icon}
        </span>
      )}
      <span className="nav-item-text">
        {children}
      </span>
    </button>
  );
};

export default NavigationItem;

